import { SAVE_INSTRUMENT_CONFIG, STRATEGY_GROPING } from '../../util/actionTypes';
const initialState ={
    instrumentConfig:{},
    strategygrouping:{}
};

const configReducer = (state =initialState, action) => {
    switch (action.type) {
        case SAVE_INSTRUMENT_CONFIG: 
            return {
                ...state,
                instrumentConfig :action.payload, 
            }; 

        case STRATEGY_GROPING: 
            return {
                ...state,
                strategygrouping :action.payload, 
            };           
  
        default:
            return state;
    }
};

export default configReducer;
